/**
 * SimpleShell — the Simple view page frame on the web: logo, the three-item
 * nav (Home / Budget / Account, 48 px targets; on narrow screens it drops to a
 * second row under the logo) and, on Home and Budget, the top switch.
 *
 * Author: Maré Greyling (Thevertex) <mare.greyling@gmail.com> — https://mare-greyling.com
 */
import { useNavigate } from 'react-router-dom';
import { TopViewSwitch } from './viewMode.jsx';

const ITEMS = [['home', 'Home', '/app'], ['budget', 'Budget', '/app?s=budget'], ['account', 'Account', '/account']];

export default function SimpleShell({ active, showSwitch = false, onNav, children }) {
  const nav = useNavigate();
  // onNav returns true when the host handled it (e.g. Home / Budget in place).
  const go = (key, to) => { if (!(onNav && onNav(key, to))) nav(to); };
  const items = ITEMS.map(([key, label, to]) => (
    <button key={key} type="button" className="sv-navbtn" aria-current={active === key ? 'page' : undefined}
            onClick={() => go(key, to)}>{label}</button>
  ));
  return (
    <div className="sv">
      <header className="sv-header with-rule">
        <div className="sv-header-row">
          <div className="sv-brand"><img src="/logo.svg" alt="" />Vault</div>
          <nav className="sv-nav" aria-label="Main">{items}</nav>
          <div style={{ flex: 1 }} />
          {showSwitch && <TopViewSwitch dataSv="pill" />}
        </div>
        <nav className="sv-nav-below" aria-label="Main">{items}</nav>
      </header>
      {children}
    </div>
  );
}
